import React from 'react'
import { useAuth0 } from '@auth0/auth0-react'

import LoginButton from './LoginButton'
import SignupButton from './signup-button'
import LogoutButton from './logout-button'

const AuthenticationButtons = () => {
  const { isAuthenticated } = useAuth0()

  if (isAuthenticated) {
    return <LogoutButton />
  }
  return (
    <div className="d-flex">
      <LoginButton caption="Log in" />
      <div className="ml-3">
        <SignupButton />
      </div>
    </div>
  )
}

export default AuthenticationButtons
